import { create } from "zustand";
import { persist } from "zustand/middleware";

const store = (set, get) => ({
  selectedStudy: undefined,
  selectedAppraisalTables: { f1: true, f2: false },
  pipelineStageData: {
    download: { pmids: [], studyName: "" },
    relevancy: { pmids: [], studyName: "" },
    appraisal: { pmids: [], studyName: "" },
    claims: { pmids: [], studyName: "" },
  },
  setSelectedStudy: (study) => set((state) => ({ selectedStudy: study })),
  setSelectedAppraisalTables: (tables) =>
    set((state) => ({ selectedAppraisalTables: tables })),
  setPipelineStage: (stage, pmids, studyName) =>
    set((state) => ({
      pipelineStageData: {
        ...state.pipelineStageData,
        [stage]: {
          pmids: Array.from(new Set((pmids || []).filter(Boolean).map(String))),
          studyName: studyName || "",
        },
      },
    })),
});

export const useClinicalEvaluationStore = create(
  persist(store, { name: "clinical-eval-store" }),
);
